export default class {
  filters = {};
  relations = [];
  relationCounts = [];
  page = 1;
  itemsPerPage = -1;
  sortBy = ['created_at'];
  sortDesc = [false];
  tourism_operator_id = false;
  totalPages = 1;
  fetchOffline = false;

  constructor(pagination) {
    Object.assign(this, pagination);
  }

  addRelation(...relations) {
    relations.forEach(function(relation) {
      if (!this.relations.includes(relation)) {
        this.relations.push(relation);
      }
    }, this);
    return this;
  }

  addRelationCounts(...relationCounts) {
    relationCounts.forEach(function(relationCount) {
      if (!this.relationCounts.includes(relationCount)) {
        this.relationCounts.push(relationCount);
      }
    }, this);
    return this;
  }

  setPage(page) {
    if (page === 3) {
      console.clear();
      console.trace();
      debugger;
    }
    this.page = page;
    return this;
  }

  setTotalPages(pages) {
    this.totalPages = pages;
    return this;
  }

  setLimit(itemsPerPage) {
    this.itemsPerPage = itemsPerPage;
    return this;
  }
  setSortOrder(sortOrder) {
    this.sortDesc = [sortOrder === 'desc'];
    return this;
  }

  setSortBy(sortBy, sortOrder = 'asc') {
    this.sortBy = [sortBy];
    this.setSortOrder(sortOrder);
    return this;
  }

  setTotal(total) {
    this.total = total;
    return this;
  }

  setFetchOffline(fetchOffline = false) {
    this.fetchOffline = fetchOffline;
    return this;
  }

  setFilters(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        this.filters[key] = obj[key];
      }
    }
    return this;
  }

  removeFilter(...keys) {
    let self = this;
    keys.forEach((key) => {
      if (self.filters[key]) {
        delete self.filters[key];
      }
    });
    return this;
  }

  withSchema() {
    this.schema = true;
    return this;
  }

  getPagination() {
    return {
      page: this.page,
      rowePerPage: this.itemsPerPage,
      filters: this.filters,
      relations: this.relations,
      relationCounts: this.relationCounts,
      sortBy: this.sortBy,
      sortDesc: this.sortDesc,
      tourism_operator_id: this.tourism_operator_id,
      date_from: this.date_from,
      date_to: this.date_to,
    };
  }

  getParamsAsQueryParam() {
    let queryParams = `limit=${this.itemsPerPage}&page=${this.page}`;
    queryParams += `&sort_order=${this.sortDesc[0] ? 'desc' : 'asc'}`;

    if (this.sortBy === 'joined_on') {
      this.sortBy = 'created_at';
    }

    if (this.date_from && this.date_from.length) {
      queryParams += `&date_from=${this.date_from}`;
    }
    if (this.date_to && this.date_to.length) {
      queryParams += `&date_to=${this.date_to}`;
    }

    if (this.sortBy && this.sortBy.length) {
      queryParams += `&sort_by=${this.sortBy[0]}`;
    }
    if (this.tourism_operator_id) {
      queryParams += `&tourism_operator_id=${this.tourism_operator_id}`;
    }

    for (const key in this.filters) {
      if (
        this.filters.hasOwnProperty(key) &&
        (this.filters[key] ||
          this.filters[key] === 0 ||
          this.filters[key] === false)
      ) {
        let value = this.filters[key];
        if (value === true) {
          value = 1;
        } else if (value === false) {
          value = 0;
        }
        queryParams += `&filter[${key}]=${value}`;
      }
    }

    if (this.relations.length) {
      queryParams += `&includes=${this.relations.join(',')}`;
    }

    if (this.relationCounts.length) {
      queryParams += `&with_count=${this.relationCounts.join(',')}`;
    }

    if (this.schema) {
      queryParams += '&schema=1';
    }

    return queryParams;
  }
}
